// @flow
import * as React from 'react'
import twitterIcon from '../../assets/images/twitter.svg'
import facebookIcon from '../../assets/images/facebook.svg'
import instagramIcon from '../../assets/images/instagram.svg'
import './styles.css'

type networkType = 'twitter' | 'facebook' | 'instagram'

type PropsType = {
  type: networkType,
  url: string
}

export default class BigDate extends React.Component<PropsType> {
  getIcon = (type: networkType): ?string => {
    switch (type) {
      case 'twitter':
        return twitterIcon
      case 'facebook':
        return facebookIcon
      case 'instagram':
        return instagramIcon
      default:
        return null;
    }
  }

  render () {
    const icon = this.getIcon(this.props.type)
    if (!icon) return null
    return (
      <div className={`social-network-container ${this.props.type}`} onClick={() => window.open(this.props.url)}>
        <img className="social-network-icon" src={icon} alt="socialNetwork"/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SocialNetwork/index.jsx